<template>
  <div
    class="tw-mb-1"
    data-walkthrough-id="recently-used-queries"
    data-testid="recently-used-queries"
  >
    <div class="tw-mt-2 sf-sub-title sf-font-l sf-below-1">
      {{ I18n.t('companies_overview.segments_new.recently_used') }}
    </div>

    <segment-list
      :segments="recentSegments"
      :loading="loading"
      :test-id="'recent-queries-list'"
      @item-click="selectSegment"
    >
      <template #static-item>
        <segment-list-item
          :segment="allClientsFakeSegment"
          :loading="loading"
          @item-click="selectAllClients"
        >
          <template #tooltip>
            <i
              v-tooltip.placementBottom="allClientsTooltip"
              class="fa fa-info-circle tw-pl-1 tw-text-sf-gray-light"
            ></i>
          </template>
        </segment-list-item>
      </template>
    </segment-list>

    <div
      v-if="recommendedSegments.length > 0"
      class="sf-sub-title sf-font-l sf-below-1 sf-pad-t-1"
      data-walkthrough-id="recommended-segments"
    >
      {{ I18n.t('companies_overview.segments_new.recommended') }}
    </div>
    <segment-list
      :segments="recommendedSegments"
      :test-id="'recommended-queries-list'"
      :loading="loading"
      @item-click="selectSegment"
    ></segment-list>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState, mapActions, mapGetters } from 'vuex'
import SegmentListItem from './segment-list-item.vue'
import SegmentList from './segment-list.vue'
import sharedSegment from '../mixins/shared-segment'

export default {
  components: {
    'segment-list-item': SegmentListItem,
    'segment-list': SegmentList,
  },
  mixins: [sharedSegment],

  computed: {
    ...mapState({
      segments: (state) => state.segments.segments,
      segment: (state) => state.segments.segment,
      recentSegmentsIds: (state) => state.recentSegments,
      companiesFullyLoaded: (state) => state.companies.companiesFullyLoaded,
      companiesFullyLoadedAt: (state) => state.companies.companiesFullyLoadedAt,
    }),
    ...mapGetters(['allCompaniesProcessed', 'getError']),
    allClientsTooltip() {
      return I18n.t('companies_overview.segments_new.show_all_files')
    },
    loading() {
      return !this.allCompaniesProcessed && !this.getError
    },
    recentSegments() {
      const r = this.recentSegmentsIds
        .map((id) =>
          this.segments.find((segment) => segment.id === parseInt(id))
        )
        .filter((segment) => segment && !segment.partner_segment_id)

      return _.uniq(r).slice(0, 5)
    },
    recommendedSegments() {
      return this.segments.filter((segment) => segment.recommended)
    },
  },

  methods: {
    ...mapActions(['loadSegment', 'unselectSegment', 'addToRecent']),

    selectSegment(segment) {
      if (!this.segment || this.segment.id !== segment.id) {
        if (!this.recentSegments.includes(segment) && !segment.recommended) {
          this.addToRecent(segment)
        }
        this.loadSegment(segment)
      }
    },
  },
}
</script>

<style scoped>
.sf-title {
  color: #262626;
  margin-bottom: 4px;
}
</style>
